<app-sccrypto-profile-popup [actualVersion]="actualVersion" [isDocument]="true" (closePopup)="close()"></app-sccrypto-profile-popup>
